import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FormApi from '../../Api/FormApi';
import FormFillerPage from './FormFillerPage';
import { FormDto } from '../../Models/FormDto';
import Loader from '../Common/Loader';

export default function FormFillerWrapperByPage({
  pageId,
}: {
  pageId: string;
}) {
  const [form, setForm] = useState<FormDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pageId) return;

    FormApi.getFormByPageId(Number(pageId))
      .then((res) => {
        setForm(res.data);
      })
      .catch((err) => {
        console.error('Error loading form for page:', err);
      })
      .finally(() => setLoading(false));
  }, [pageId]);

  if (loading) return <Loader />;
  if (!form) return <p></p>;

  return <FormFillerPage formId={form.formId!} />;
}
